package org.gymly.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import org.gymly.model.AdminClientStatus
import org.gymly.model.AdminMembershipAccessMode
import org.gymly.model.AdminMembershipStatus
import org.gymly.model.AdminPersonSex
import org.gymly.model.AdminProductStockLevel

/** Etiquetas de enums según el idioma activo del panel. */

@Composable
@ReadOnlyComposable
fun AdminPersonSex.label(): String = strings().common.sexLabel(this)

@Composable
@ReadOnlyComposable
fun AdminClientStatus.label(): String = when (this) {
    AdminClientStatus.ACTIVE -> strings().common.active
    AdminClientStatus.INACTIVE -> strings().common.inactive
}

@Composable
@ReadOnlyComposable
fun AdminMembershipStatus.label(): String {
    val en = strings().locale == GymlyLocale.EN
    return when (this) {
        AdminMembershipStatus.ACTIVE -> if (en) "Active" else "Activa"
        AdminMembershipStatus.EXPIRED -> if (en) "Expired" else "Vencida"
        AdminMembershipStatus.CANCELLED -> if (en) "Cancelled" else "Cancelada"
    }
}

@Composable
@ReadOnlyComposable
fun AdminMembershipAccessMode.label(): String {
    val en = strings().locale == GymlyLocale.EN
    return when (this) {
        AdminMembershipAccessMode.AUTO -> if (en) "Automatic" else "Automática"
        AdminMembershipAccessMode.MANUAL_ACTIVE -> if (en) "Manually active" else "Activa manual"
        AdminMembershipAccessMode.MANUAL_BLOCKED -> if (en) "Manually blocked" else "Bloqueada manual"
    }
}

@Composable
@ReadOnlyComposable
fun AdminProductStockLevel.label(): String {
    val en = strings().locale == GymlyLocale.EN
    return when (this) {
        AdminProductStockLevel.OK -> "OK"
        AdminProductStockLevel.LOW -> if (en) "Low stock" else "Poco stock"
        AdminProductStockLevel.OUT -> if (en) "Out of stock" else "Agotado"
    }
}
